import { render, staticRenderFns } from "./SearchColumnKeyword.vue?vue&type=template&id=452c353a"
import script from "./SearchColumnKeyword.vue?vue&type=script&lang=js"
export * from "./SearchColumnKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports